import ScrollMenu from '~/scripts/lib/ScrollMenu';

export default (function() {
  var ArticlesShow = function() {
    new ScrollMenu("#article-menu", ".article-list");
  };

  return ArticlesShow;
})();
